import NovoCardLouvor from "../../Components/NovoCardLouvor/NovoCardLouvor";
import PageHeader from "../../Components/PageHeader/PageHeader";
import CardsHeaderMinisterio from "../../Components/CardsHeaderMinisterio/CardsHeaderMinisterio";
import "./Louvor.css";
import { useEffect, useState, useMemo } from "react";
import api from "../../services/api.js";
import ClipLoader from "react-spinners/ClipLoader";
import { SetBoxColor } from "../../Utils/setBoxColor.js";
import MenuMesesLouvor from "../../Components/MenuMesesLouvor/MenuMesesLouvor.jsx";
import FabBackToTop from "../../Components/FabBackToTop/FabBackToTop.jsx";

export default function Louvor() {
  const [escalas, setEscalas] = useState(null);
  const [mesesSelecionados, setMesesSelecionados] = useState([]);

  const toggleMes = (mes) => {
    setMesesSelecionados((prev) =>
      prev.includes(mes) ? prev.filter((m) => m !== mes) : [...prev, mes]
    );
  };

  const escalasFiltradas = useMemo(() => {
    return escalas?.filter((item) => mesesSelecionados.includes(item.mes));
  }, [mesesSelecionados, escalas]);

  let Dt_Today = new Date();
  Dt_Today.setDate(Dt_Today.getDate() - 1);

  useEffect(() => {
    api
      .get(
        "/Escalas/TodasFuturasEscalas?IdMinisterio=1&DataCorte=" +
          Dt_Today.toISOString()
      )
      .then((response) => {
        var _escalasPorMes = groupByMonth(response.data);
        setEscalas(_escalasPorMes);
        setMesesSelecionados([_escalasPorMes[0]?.mes]);
      });
  }, []);

  const groupByMonth = (array) => {
    const agrupado = array.reduce((acc, escala) => {
      const dataEscala = new Date(escala.servico.data);
      const mes = dataEscala.toLocaleString("pt-BR", { month: "long" });

      if (!acc[mes]) {
        acc[mes] = [];
      }

      acc[mes].push(escala);
      return acc;
    }, {});

    return Object.keys(agrupado).map((mes) => ({
      mes,
      escalas: agrupado[mes],
    }));
  };

  return (
    <div>
      <PageHeader />
      <div id="hd_Louvor">
        <CardsHeaderMinisterio txt_Ministerio="Louvor" />
      </div>

      <div id="dv_container_Escala">
        {!escalasFiltradas ? (
          <ClipLoader color={"#43715D"} size={150} speedMultiplier={1} />
        ) : (
          <>
            <MenuMesesLouvor mesesSelecionados={mesesSelecionados} toggleMes={toggleMes} meses={escalas} />
            {escalasFiltradas?.map((escala, i) => (
              <>
                {escala?.escalas?.map((item, j) => {
                  return (
                    <NovoCardLouvor
                      key={j}
                      informacoes={{
                        color: SetBoxColor(j),
                        dados: item,
                      }}
                    />
                  );
                })}
              </>
            ))}
          </>
        )}
      </div>
      <FabBackToTop />
    </div>
  );
}
